export default "__VITE_ASSET__DRj47U8Y__"